// extracted by mini-css-extract-plugin
export default {"textBox":"text-dnd_textBox__k1AW8"};